import React, { useState, useEffect } from "react";
import "../CommonCssFiles/planstyle.css";
import { Checkbox, FormControlLabel } from "@mui/material";
import "./ICICI.css";

export const ICICIQuestionAnswer = ({
  data,
  ICICIcheckedQuestion,
  setICICICheckedQuestion,
  medErrors,
  setMedErrors,
}) => {
  const updateICICIQuestion = (val) => {
    setICICICheckedQuestion((prevState) => {
      const updatedState = { ...prevState };

      if (updatedState.hasOwnProperty(val.val)) {
        delete updatedState[val.val];
      } else {
        updatedState[val.val] = {};
      }

      return updatedState;
    });
  };

  useEffect(() => {
    if (medErrors.length > 0) {
      const firstErrorElement = document.querySelector(
        `[data-question-id="${medErrors[0]}"]`
      );
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, [medErrors]);

  return (
    <>
      {/* <div className="icici-question-box col-md-12">
        <FormControlLabel
          className="checkbox-div"
          value={data.question_id}
          onChange={(e) => updateICICIQuestion({ val: e.target.value })}
          control={<Checkbox className="checkbox-div-box" />}
          label={"Q." + data.question}
          checked={ICICIcheckedQuestion.hasOwnProperty(data.question_id)}
        />
      </div> */}
      <div
        className="all-que-div col-md-12"
        data-question-id={data.question_id}
      >
        <div
          className={
            medErrors.includes(data.question_id)
              ? "col-md-12 pmd-all med-error-present"
              : "col-md-12 pmd-all med-error-absent"
          }
        >
          <FormControlLabel
            // className="checkbox-div"
            value={data.question_id}
            onChange={(e) => {
              const isChecked = e.target.checked;
              updateICICIQuestion({ val: e.target.value });
              if (!isChecked) {
                setMedErrors((prevErrors) =>
                  prevErrors.filter((id) => id !== data.question_id)
                );
              }
            }}
            // control={<Checkbox className="checkbox-div-box" />}
            control={
              <Checkbox
                className={
                  medErrors.includes(data.question_id)
                    ? "checkbox-error"
                    : "checkbox-normal"
                }
              />
            }
            label={"Q." + data.question}
            // checked={ICICIcheckedQuestion.hasOwnProperty(data.question_id)}

            checked={ICICIcheckedQuestion.hasOwnProperty(data.question_id)}
            className={
              medErrors.includes(data.question_id)
                ? "label-error"
                : "label-normal"
            }
          />
        </div>
      </div>
    </>
  );
};

export const ICICIPersion = ({
  data,
  persion,
  pindex,
  proposerData,
  ICICIcheckedQuestion,
  setICICICheckedQuestion,
}) => {
  const check = () => {
    if (ICICIcheckedQuestion.hasOwnProperty(data.question_id)) {
      if (ICICIcheckedQuestion[data.question_id].hasOwnProperty(pindex)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const updateICICIPersion = (payloadData) => {
    const { question_id, pindex } = payloadData;

    setICICICheckedQuestion((prevState) => {
      const updatedState = { ...prevState };

      if (updatedState[question_id]) {
        if (updatedState[question_id].hasOwnProperty(pindex)) {
          delete updatedState[question_id][pindex];
        } else {
          updatedState[question_id][pindex] = {};
        }
      }

      return updatedState;
    });
  };

  return (
    <>
      <div
        className="col-md-6"
        hidden={!ICICIcheckedQuestion.hasOwnProperty(data.question_id)}
        onClick={(e) =>
          updateICICIPersion({ pindex: pindex, question_id: data.question_id })
        }
      >
        <div
          className={check() ? "icici-clicked-person" : "icici-unclick-person"}
        >
          <div className="">
            {/* <span className='para'>{proposerData.InsuredDetail[pindex].InsuredName} ({persion.InsuredRelation}) </span> */}
            <span className={check() ? "para" : "para-unchecked"}>
              {proposerData?.InsuredDetail[pindex]?.InsuredName}
              <span className={check() ? "para-relation" : "para-rel"}>
                ({persion?.InsuredRelation})
              </span>{" "}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
